import React from 'react';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import classnames from 'classnames';
import cn from './styles.module.scss';

interface HeaderMenuProps extends MenuProps {
  centered?: boolean;
}

export const HeaderMenu = ({
  mode = 'horizontal',
  centered = true,
  className,
  ...rest
}: HeaderMenuProps) => {
  return (
    <Menu
      mode={mode}
      className={classnames(cn.headerMenu, centered && cn.centered, className)}
      {...rest}
    />
  );
};
